import TableRow from "components/tableRow";

function HorseRacingInPlay() {
    return (
        <>
            <div className='relative w-full'>
                <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Horse Racing</p>
            </div>
            <div className="bg-[#fff] text-[#000] py-1 flex ">
                <span className="border-[1px] border-[solid] border-[#7e97a7] rounded-[4px] text-[#7e97a7] text-[11px] leading-[16px] ml-[5px] mr-[5px] min-w-[75px] px-[5px] py-[0] flex items-center w-auto">Coming Up</span>
                <div className="overflow-hidden">
                    <div className="whitespace-nowrap">
                        <ul className="inline-block">
                            <li className="cursor-pointer inline-block">
                                <a className="text-[#030303] !cursor-pointer text-[13px] font-bold flex items-center">
                                    <img className="h-auto mr-px w-[15px]" src="/assets/svg/horse.svg" />
                                    <span className="mr-1">17:10</span>
                                    Globe Derby (AUS) 15th Feb
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HorseRacingInPlay;
